import Select from "react-select";
import useAddJewellery, {
  jewelleryMediaType,
  jewellerySpecOptionType,
  jewellerySpecType,
} from "../hooks/useAddJewellery";
import JewelleryMedia from "../JewelleryMedia";
import TableContainer from "Common/TableContainer";
import { FileEdit, Loader2, Plus, Trash2 } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import {
  categoryType,
  setIsDuplicate,
  setIsEditing,
  subcategoryType,
} from "slices/jewellery/reducer";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getJewelleryById as onGetJewelleryById } from "slices/thunk";
import AddDiamondModel from "../AddDiamondModel";
import DeleteModal from "Common/DeleteModal";
import CreatableSelect from "react-select/creatable";

interface Option {
  readonly label: string;
  readonly value?: string;
  readonly options?: Option[];
  readonly isDisabled?: boolean;
}

/* eslint-disable react-hooks/exhaustive-deps */
const AddJewelleryForm = ({
  jewelleryMedia,
  setJewelleryMedia,
  deletedImagesUrls,
  setDeletedImagesUrls,
}: {
  jewelleryMedia: jewelleryMediaType[];
  setJewelleryMedia: (val: jewelleryMediaType[]) => void;
  deletedImagesUrls: string[];
  setDeletedImagesUrls: (val: string[]) => void;
}) => {
  const [isShowError, setIsShowError] = useState<boolean>(false);
  const { id } = useParams();

  const dispatch = useDispatch<any>();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    // setIsShowError,
    addJewelleryForm,
    jewellerySpecs,
    diamonds,
    handleUpdateDiamondClick,
    isDuplicate,
    isEditing,
    isLoading,
    isProductDataUpdated,
    setClickOnUpdate,
    clickOnUpdate,
    setClickOnCreate,
    clickOnCreate,
    clickOnDraft,
    setClickOnDraft,
    checkIsProductDataUpdated,
    jewellery,
    eventData,
    setEventData,
    // setJewelleryMedia,
    handleSetProductData,
    handleJewellerySubCategoryOptions,
    isEdit,
    setDiamonds,
    diamondEventData,
    setDiamondEventData,
    setIsEdit,
    show,
    setShow,
    setIsShowDeleteDiamondConfirmModel,
    setDeleteDiamondIndex,
    isShowDeleteDiamondConfirmModel,
    handleDeleteDiamond,
    categoriesToShowBandWidth,
    handleDuplicateData,
    categories,
    defaultJewelleryMedia,
  } = useAddJewellery({
    jewelleryMedia,
    setJewelleryMedia,
    deletedImagesUrls,
    setDeletedImagesUrls,
  });

  const columns = useMemo(
    () => [
      {
        header: (
          <div className="flex items-center h-full">
            <input
              id="CheckboxAll"
              className="size-4 cursor-pointer bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800"
              type="checkbox"
            />
          </div>
        ),
        enableSorting: false,
        id: "checkAll",
        cell: (cell: any) => {
          return (
            <div className="flex items-center h-full">
              <input
                id={"Checkbox" + cell.row.original.id}
                className="size-4 cursor-pointer bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800"
                type="checkbox"
              />
            </div>
          );
        },
      },

      {
        header: "Shape",
        accessorKey: "shape",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <span className="category px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-slate-100 border-slate-200 text-slate-500 dark:bg-slate-500/20 dark:border-slate-500/20 dark:text-zink-200">
            {cell.getValue()}
          </span>
        ),
      },
      {
        header: "Color",
        accessorKey: "color",
        enableColumnFilter: false,
      },
      {
        header: "Clarity",
        accessorKey: "clarity",
        enableColumnFilter: false,
      },
      {
        header: "Carat",
        accessorKey: "carat",
        enableColumnFilter: false,
      },
      {
        header: "No Of diamonds",
        accessorKey: "pieces",
        enableColumnFilter: false,
      },

      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any, i: number) => (
          <div className="flex items-center justify-center gap-2">
            {/* <a
              href="#!"
              className="flex items-center justify-center size-8 transition-all duration-150 ease-linear rounded-md bg-slate-100 hover:bg-slate-200 dark:bg-zink-600 dark:hover:bg-zink-500"
            >
              <Eye className="size-3"></Eye>
            </a> */}
            <a
              href="#!"
              className="flex items-center justify-center size-8 transition-all duration-150 ease-linear rounded-md bg-slate-100 hover:bg-slate-200 dark:bg-zink-600 dark:hover:bg-zink-500"
              onClick={() => {
                const data = cell.row.original;
                handleUpdateDiamondClick(data);
                setShow(true);
              }}
            >
              <FileEdit className="size-3"></FileEdit>
            </a>
            <a
              href="#!"
              className="flex items-center justify-center size-8 transition-all duration-150 ease-linear rounded-md bg-slate-100 hover:bg-slate-200 dark:bg-zink-600 dark:hover:bg-zink-500"
              onClick={() => {
                const data = cell.row;
                setDeleteDiamondIndex(data.index);
                setIsShowDeleteDiamondConfirmModel(true);
              }}
            >
              <Trash2 className="size-3"></Trash2>
            </a>
          </div>
        ),
      },
    ],
    []
  );

  const diamondsTable = useMemo(() => {
    return diamonds && diamonds.length ? (
      <TableContainer
        isPagination={false}
        columns={columns || []}
        data={diamonds || []}
        customPageSize={10}
        divclassName="mt-5 overflow-x-auto"
        tableclassName="w-full whitespace-nowrap"
        theadclassName="text-center bg-slate-100 dark:bg-zink-600"
        thclassName="text-center px-3.5 py-2.5 font-semibold text-slate-500 border-b border-slate-200 dark:border-zink-500 dark:text-zink-200"
        tdclassName="text-center px-3.5 py-2.5 border-y border-slate-200 dark:border-zink-500"
        PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
      />
    ) : (
      <div className="noresult">
        <div className="py-6 text-center">
          <h5 className="mt-2 mb-1">Diamonds not available</h5>
        </div>
      </div>
    );
  }, [diamonds, diamonds.length]);

  const handleSubCategoryOnCategoryChange = (category: string) => {
    if (category !== (jewellery?.category || "")) {
      addJewelleryForm.setFieldValue("subcategory", "");
    } else if (category === jewellery?.category) {
      const currentCategory: categoryType = categories.find(
        ({ _id, name }: { _id: string; name: string }) =>
          category === _id || category === name
      );

      if (currentCategory?.subcategories?.length) {
        const currentSubCategory: subcategoryType =
          currentCategory.subcategories.find(
            (subcat: subcategoryType) => subcat?.name === jewellery?.subcategory
          ) as subcategoryType;
        addJewelleryForm.setFieldValue("subcategory", currentSubCategory?._id);
      } else {
        addJewelleryForm.setFieldValue("subcategory", "");
      }
    }
  };

  const checkIsMediaUploaded = (
    jewelleryMedia: jewelleryMediaType[]
  ): boolean => {
    return jewelleryMedia.some(
      (media) => media.files.length > 0 || media.images.length > 0
    );
  };


  useEffect(() => {
    if (
      isEditing &&
      jewellery &&
      location?.pathname.includes("/update-jewellery")
    ) {
      handleSetProductData();
    }
  }, [isEditing, jewellery, location]);

  useEffect(() => {
    if (
      isDuplicate &&
      jewellery &&
      location?.pathname.includes("/duplicate-jewellery")
    ) {
      handleDuplicateData();
    }
  }, [isDuplicate, jewellery, location]);

  useEffect(() => {
    isEditing && checkIsProductDataUpdated();
  }, [isEditing, addJewelleryForm, eventData, diamonds]);

  useEffect(() => {
    if (id) {
      dispatch(onGetJewelleryById(id));
    }
  }, [id]);

  useEffect(() => {
    if (location?.pathname === "/add-jewellery") {
      isEditing && dispatch(setIsEditing(false));
      setEventData({
        _id: "",
        title: "",
        sku: "",
        category: "",
        subcategory: "",
        gender: "",
        description: "",
        status: "",
        shape: "",
        visibility: "",
        media: [],
        metal: { "14k": null, "18k": null, platinum: null },
        diamonds: [],
        tags: [],
        bandWidth: null,
      });
      setJewelleryMedia([
        {
          id: "",
          type: "yellowgold",
          label: "Yellow Gold",
          files: [],
          images: [],
        },
        { id: "", type: "rosegold", label: "Rose Gold", files: [], images: [] },
        {
          id: "",
          type: "whitegold",
          label: "White Gold",
          files: [],
          images: [],
        },
      ]);
    }
  }, [location]);

  useEffect(() => {
    if (location?.pathname && jewellery?._id) {
      if (location.pathname === `/update-jewellery/${jewellery._id}`) {
        !isEditing && dispatch(setIsEditing(true));
      }
    }
  }, [location, jewellery]);

  useEffect(() => {
    if (location?.pathname && jewellery?._id) {
      if (location.pathname === `/duplicate-jewellery/${jewellery._id}`) {
        !isDuplicate && dispatch(setIsDuplicate(true));
      }
    }
  }, [location, jewellery]);

const jewelleryImages = jewelleryMedia.some(
  (media) => media.files?.length > 0 || media.images?.length > 0
);

  return (
    <>
      <AddDiamondModel
        show={show}
        setShow={setShow}
        diamonds={diamonds}
        setDiamonds={setDiamonds}
        diamondEventData={diamondEventData}
        setDiamondEventData={setDiamondEventData}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
      />
      <DeleteModal
        show={isShowDeleteDiamondConfirmModel}
        onHide={() => {
          setIsShowDeleteDiamondConfirmModel(false);
        }}
        message="You want to delete the diamond?"
        onDelete={handleDeleteDiamond}
      />

      <form
        action="#!"
        onSubmit={(e) => {
          e.preventDefault();
          const isMedisUploaded = checkIsMediaUploaded(jewelleryMedia);
          if (isMedisUploaded) {
            addJewelleryForm.handleSubmit();
            setIsShowError(false); // Hide error if media is uploaded
          } else {
            setIsShowError(true); // Show error if no media is uploaded
          }
          // isMedisUploaded && addJewelleryForm.handleSubmit();
          // setIsShowError(true);
          // return false;
        }}
        onReset={() => {
          addJewelleryForm.resetForm();
          setJewelleryMedia(defaultJewelleryMedia);
          setDiamonds([]);
        }}
      >
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
          <div className="xl:col-span-6">
            <label
              htmlFor="productNameInput"
              className="inline-block mb-2 text-base font-medium"
            >
              Product Title
            </label>
            <input
              type="text"
              id="productNameInput"
              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="Product title"
              name="title"
              value={addJewelleryForm.values.title || ""}
              onChange={(e) => {
                addJewelleryForm.setFieldValue("title", e.target.value);
                const skuValue = e.target.value
                  .toLowerCase()
                  .trim()
                  .replace(/\s+/g, "-");
                addJewelleryForm.setFieldValue("sku", skuValue);
              }}
              disabled={isLoading}
            />

            {addJewelleryForm.touched.title && addJewelleryForm.errors.title ? (
              <p className="mt-1 text-sm text-red-400">
                {addJewelleryForm.errors.title}
              </p>
            ) : (
              <p className="mt-1 text-sm text-slate-400 dark:text-zink-200">
                Do not exceed 100 characters when entering the product name.
              </p>
            )}
          </div>
          <div className="xl:col-span-6">
            <label
              htmlFor="productSku"
              className="inline-block mb-2 text-base font-medium"
            >
              SKU
            </label>
            <input
              type="text"
              id="productSku"
              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="SKU"
              name="sku"
              value={addJewelleryForm.values.sku || ""}
              onChange={addJewelleryForm.handleChange}
              disabled
            />

            {addJewelleryForm.touched.sku && addJewelleryForm.errors.sku && (
              <p className="mt-1 text-sm text-red-400">
                {addJewelleryForm.errors.sku}
              </p>
            )}
          </div>
          {jewellerySpecs.map(
            (jewellerySpec: jewellerySpecType, index: number) => {
              const selectedOption: jewellerySpecOptionType | undefined =
                jewellerySpec.options?.find(
                  (option) =>
                    option.value === addJewelleryForm.values[jewellerySpec.type]
                );

              const isSubcategoryDisabled: boolean =
                jewellerySpec.type === "subcategory" &&
                !addJewelleryForm.values["category"];

              return (
                <div
                  className={`${
                    isSubcategoryDisabled
                      ? "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
                      : "bg-white dark:bg-zink-700 dark:text-zink-100"
                  } xl:col-span-4`}
                  key={`jewellery-spec-${index}`}
                >
                  <label
                    htmlFor={`${jewellerySpec.type}-${index}`}
                    className="inline-block mb-2 text-base font-medium"
                  >
                    {jewellerySpec.label}
                  </label>
                  <Select
                    className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    options={jewellerySpec.options}
                    isDisabled={isLoading || isSubcategoryDisabled}
                    value={selectedOption}
                    name={jewellerySpec.type}
                    id={`${jewellerySpec.type}-${index}`}
                    placeholder={`Select ${jewellerySpec.label}`}
                    onChange={(data: any) => {
                      addJewelleryForm.setFieldValue(
                        jewellerySpec.type,
                        data?.value || ""
                      );
                      if (jewellerySpec.type === "category") {
                        handleJewellerySubCategoryOptions(data?.value || "");
                        handleSubCategoryOnCategoryChange(data?.label || "");
                      }
                    }}
                  />
                  {addJewelleryForm.touched[`${jewellerySpec.type}`] &&
                    addJewelleryForm.errors[`${jewellerySpec.type}`] && (
                      <p className="mt-1 text-sm text-red-400">
                        {addJewelleryForm.errors[`${jewellerySpec.type}`]}
                      </p>
                    )}
                </div>
              );
            }
          )}
          {categoriesToShowBandWidth.includes(
            addJewelleryForm.values.category
          ) && (
            <div className="xl:col-span-4">
              <label
                htmlFor="bandWidth"
                className="inline-block mb-2 text-base font-medium"
              >
                Band Width
              </label>
              <input
                type="text"
                id="bandWidth"
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter band width in millimeters"
                name="bandWidth"
                value={addJewelleryForm.values.bandWidth || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    // Allows only numbers and a single dot
                    addJewelleryForm.setFieldValue("bandWidth", value);
                  }
                }}
                disabled={isLoading}
              />
              {addJewelleryForm.touched.bandWidth &&
                addJewelleryForm.errors.bandWidth && (
                  <p className="mt-1 text-sm text-red-400">
                    {addJewelleryForm.errors.bandWidth}
                  </p>
                )}
            </div>
          )}
          <JewelleryMedia
            jewelleryMedia={jewelleryMedia}
            setJewelleryMedia={setJewelleryMedia}
            deletedImagesUrls={deletedImagesUrls}
            setDeletedImagesUrls={setDeletedImagesUrls}
            isShowError={isShowError}
          />
          {isShowError && !jewelleryImages && (
            <p className="mt-1 text-sm text-red-400">
             please upload image for at least one metal type (yellow gold, rose gold, or white gold).
            </p>
          )}
          <div className="lg:col-span-2 xl:col-span-12">
            <div>
              <label
                htmlFor="productDescription"
                className="inline-block mb-2 text-base font-medium"
              >
                Description
              </label>
              <textarea
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 disabled:cursor-not-allowed"
                id="productDescription"
                placeholder="Enter Description"
                name="description"
                rows={5}
                value={addJewelleryForm.values.description || ""}
                onChange={addJewelleryForm.handleChange}
                disabled={isLoading}
              ></textarea>
            </div>
            {addJewelleryForm.touched.description &&
            addJewelleryForm.errors.description ? (
              <p className="mt-1 text-sm text-red-400">
                {addJewelleryForm.errors.description}
              </p>
            ) : null}
          </div>
          <div className="xl:col-span-12">
            <h6>Metal</h6>
          </div>
          <div className="xl:col-span-4">
            <label
              htmlFor="14k"
              className="inline-block mb-2 text-base font-medium"
            >
              14K
            </label>
            <input
              type="text"
              id="14k"
              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="0.00 Gm"
              name="metal.14k"
              onChange={addJewelleryForm.handleChange}
              value={addJewelleryForm.values.metal["14k"]}
            />
            {addJewelleryForm.touched.metal &&
            addJewelleryForm.touched.metal["14k"] &&
            addJewelleryForm.errors.metal &&
            addJewelleryForm.errors?.metal["14k"] ? (
              <p className="mt-1 text-sm text-red-400">
                {addJewelleryForm.errors.metal["14k"]}
              </p>
            ) : null}
          </div>
          <div className="xl:col-span-4">
            <label
              htmlFor="18k"
              className="inline-block mb-2 text-base font-medium"
            >
              18K
            </label>
            <input
              type="text"
              id="18k"
              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="0.00 Gm"
              name="metal.18k"
              onChange={addJewelleryForm.handleChange}
              value={addJewelleryForm.values.metal["18k"]}
            />
            {addJewelleryForm.touched.metal &&
            addJewelleryForm.touched.metal["18k"] &&
            addJewelleryForm.errors.metal &&
            addJewelleryForm.errors.metal["18k"] ? (
              <p className="mt-1 text-sm text-red-400">
                {addJewelleryForm.errors.metal["18k"]}
              </p>
            ) : null}
          </div>
          <div className="xl:col-span-4">
            <label
              htmlFor="platinum"
              className="inline-block mb-2 text-base font-medium"
            >
              platinum
            </label>
            <input
              type="text"
              id="platinum"
              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              name="metal.platinum"
              placeholder="0.00 Gm"
              onChange={addJewelleryForm.handleChange}
              value={addJewelleryForm.values.metal.platinum}
            />
            {addJewelleryForm.touched.metal &&
            addJewelleryForm.touched.metal.platinum &&
            addJewelleryForm.errors.metal &&
            addJewelleryForm.errors.metal.platinum ? (
              <p className="mt-1 text-sm text-red-400">
                {addJewelleryForm.errors.metal.platinum}
              </p>
            ) : null}
          </div>
          <div className="xl:col-span-12">
            <label
              htmlFor="tags"
              className="inline-block mb-2 text-base font-medium"
            >
              Tags
            </label>
            <CreatableSelect
              className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              id="tags"
              data-choices
              data-choices-remove-item
              data-choices-text-unique-true
              data-choices-limit="5"
              isMulti
              delimiter={"true"}
              onChange={(data: any) => {
                let tags: string[] = data.map((tag: Option) => tag.value);
                data.length <= 5 &&
                  addJewelleryForm.setFieldValue("tags", tags);
              }}
              value={addJewelleryForm.values.tags.map((tag: string) => {
                return { label: tag, value: tag };
              })}
              // options={}
            />
            {addJewelleryForm.touched.tags && addJewelleryForm.errors.tags ? (
              <p className="mt-1 text-sm text-red-400">
                {addJewelleryForm.errors.tags}
              </p>
            ) : null}
          </div>

          <h6>Diamonds</h6>
          <div className="lg:col-span-2 lg:col-start-11">
            <div className="ltr:lg:text-right rtl:lg:text-left">
              <button
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                onClick={() => {
                  setShow(true);
                }}
              >
                <Plus className="inline-block size-4" />
                <span className="align-middle">Add Diamond</span>
              </button>
            </div>
          </div>
          <div className="xl:col-span-12">{diamondsTable}</div>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          {isDuplicate ? (
            // Show only the Duplicate button
            <button
              type="button"
              className="flex items-center text-white bg-blue-500 border-blue-500 btn hover:text-white hover:bg-blue-600 hover:border-blue-600 focus:text-white focus:bg-blue-600 focus:border-blue-600 focus:ring focus:ring-blue-100 active:text-white active:bg-blue-600 active:border-blue-600 active:ring active:ring-blue-100 dark:ring-blue-400/10 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                  Duplicating...
                </>
              ) : (
                "Duplicate Product"
              )}
            </button>
          ) : isEditing ? (
            <>
              <button
                type="reset"
                data-modal-close="addDocuments"
                className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500"
                onClick={() => {
                  addJewelleryForm.resetForm();
                  // setJewelleryMedia([...jewelleryMedia])
                  navigate("/jewellery");
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isLoading || !isProductDataUpdated}
                onClick={() => {
                  setClickOnUpdate(true);
                }}
              >
                {clickOnUpdate && isLoading ? (
                  <>
                    <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                    Updating...
                  </>
                ) : (
                  "Update Product"
                )}
              </button>
            </>
          ) : (
            <>
              <button
                type="reset"
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-700 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10 disabled:cursor-not-allowed"
                disabled={isLoading}
              >
                Reset
              </button>
              <button
                type="submit"
                className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isLoading}
                onClick={() => {
                  setClickOnCreate(true);
                  clickOnDraft && setClickOnDraft(false);
                }}
              >
                {clickOnCreate && isLoading ? (
                  <>
                    <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                    Processing...
                  </>
                ) : (
                  "Create Product"
                )}
              </button>
              {/* <button
                type="submit"
                className="flex items-center text-white bg-green-500 border-green-500 btn hover:text-white hover:bg-green-600 hover:border-green-600 focus:text-white focus:bg-green-600 focus:border-green-600 focus:ring focus:ring-green-100 active:text-white active:bg-green-600 active:border-green-600 active:ring active:ring-green-100 dark:ring-green-400/10 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isLoading}
                onClick={() => {
                  setClickOnDraft(true);
                  clickOnCreate && setClickOnCreate(false);
                }}
              >
                {clickOnDraft && isLoading ? (
                  <>
                    <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                    Processing...
                  </>
                ) : (
                  "Draft & Preview"
                )}
              </button> */}
            </>
          )}
        </div>
      </form>
    </>
  );
};

export default AddJewelleryForm;
